import Repository from './Repository';

const resource = '/default';

export default class ValidationRepository {
  static validate(stepid, data) {
    return Repository.post(`${resource}/validate`, { stepid, data });
  }
}
